export const AccordionWidgetId = 'AccordionWidget';

export enum AccordionWidgetAttributes {
  ELEMENTS = 'elements',
}
